var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticStyle:{"z-index":"9999"},attrs:{"value":_vm.isLoading,"opacity":"0.6"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }